import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Parser, ProcessNodeDefinitions } from 'html-to-react'
import Editor from 'components/EditorNext'
import Button from 'components/theme/Button'
import AceEditor from 'react-ace'
import pretty from 'pretty'
import 'brace/mode/html'
import 'brace/theme/monokai'
import { handleSectionValueChange } from 'actions/customForm/addOrEdit'

const parser = new Parser()
var isValidNode = function () {
	return true
}

var processNodeDefinitions = new ProcessNodeDefinitions(React)
var preprocessingInstructions = [
	{
		shouldPreprocessNode: function (node) {
			return Boolean(node.name) && node.name === 'a'
		},
		preprocessNode: function (node) {
			node.attribs = { id: `preprocessed-${node.attribs.id}` }
		},
	},
]
var processingInstructions = [
	{
		// Anything else
		shouldProcessNode: function (node) {
			return true
		},
		processNode: processNodeDefinitions.processDefaultNode,
	},
]

const htmlcontent = ({
	isEditing,
	isDragging,
	item,
	handleSectionValueChange,
}) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [codeEditorDisplayed, setDisplay] = useState(false)

	return isEditing ? (
		<div
			style={
				{
					// height: 42,
					// margin: 10,
					// border: isDragging ? 'none' : '1px solid #000',
				}
			}
		>
			<div
				style={{ marginBottom: 10, paddingTop: codeEditorDisplayed ? 10 : 0 }}
			>
				{codeEditorDisplayed ? (
					<AceEditor
						// className="ignore-react-onclickoutside"
						width="100%"
						mode="html"
						theme="monokai"
						name="blah2"
						onChange={(value) =>
							handleSectionValueChange({
								id: item.id,
								property: 'htmlcontent',
								value: { HtmlPart: value },
							})
						}
						fontSize={12}
						showPrintMargin={true}
						wrapEnabled={true}
						showGutter={true}
						highlightActiveLine={true}
						value={pretty(item?.htmlcontent?.HtmlPart || '')}
						setOptions={{
							showLineNumbers: true,
							tabSize: 2,
						}}
						debounceChangePeriod={1500}
						height={564}
					/>
				) : (
					<Editor
						onChange={(value) =>
							handleSectionValueChange({
								id: item.id,
								property: 'htmlcontent',
								value: { HtmlPart: value },
							})
						}
						contentHeight={350}
						value={item?.htmlcontent?.HtmlPart || ''}
					/>
				)}
			</div>
			<Button onClick={() => setDisplay(!codeEditorDisplayed)}>
				Edit {codeEditorDisplayed ? 'content' : 'code'}
			</Button>
		</div>
	) : (
		<div>
			{parser.parseWithInstructions(
				item?.htmlcontent?.HtmlPart || '',
				isValidNode,
				processingInstructions,
				preprocessingInstructions,
			)}
		</div>
	)
}

export default connect(null, (dispatch) =>
	bindActionCreators({ handleSectionValueChange }, dispatch),
)(htmlcontent)
